import 'edge/endorsement/common/models/PolicyChange';

var HOPolicyChangeDraftDataExtension = function HOPolicyChangeDraftDataExtension(policyChange) {
    var data = policyChange.lobData.homeowners;

    if (data) {
        this.coverables = data.coverables;
        this.coverables.additionalInterests = this.coverables.additionalInterests || [];
        this.offerings = data.offerings;

        if (angular.isDefined(policyChange.history)) {
            _buildHistory(policyChange, this);
        } else {
            policyChange.history = [];
        }
    }
};

function _buildHistory(policyChange, lob) {
    var coverages = lob.offerings[0].coverages;
    var coverables = lob.coverables;

    var _loop = function _loop(i) {
        var historyItem = policyChange.history[i];
        if (historyItem.entityType === 'mortgagee') {
            historyItem.entity = coverables.additionalInterests.find(function (ai) {
                return ai.fixedId === historyItem.fixedId;
            });
        } else if (historyItem.entityType === 'coverage') {
            historyItem.entity = coverages.schedules.find(function (c) {
                return c.fixedId === historyItem.fixedId;
            });
        }
    };

    for (var i = 0; i < policyChange.history.length; i++) {
        _loop(i);
    }
}

export default HOPolicyChangeDraftDataExtension;


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=Homeowners!./common/js/src/edge/endorsement/ho/models/HOPolicyChangeDataExtension.js
// module id = 443
// module chunks = 0